import { TIMING } from './constants'
import { useToolbarContext } from './ToolbarContext'

interface ToolbarItemProps {
	children: React.ReactNode
}

/**
 * Auto-animated wrapper for toolbar items
 * Automatically registers itself and calculates animation delays
 * No manual index prop needed - handled via context
 */
export const ToolbarItem: React.FC<ToolbarItemProps> = ({ children }) => {
	const { isAnimating, showContent, registerItem } = useToolbarContext()

	// Register item and get index - must be called during render
	// This ensures items are registered in the order they appear in the tree
	const index = registerItem()

	const expandDelay = `${TIMING.BASE_DELAY_MS + index * TIMING.STAGGER_MS}ms`
	const collapseDelay = `${(TIMING.MAX_ITEMS - index) * TIMING.COLLAPSE_STAGGER_MS}ms`

	return (
		<div
			className="collapsible-toolbar__item"
			data-expanding={isAnimating && showContent}
			style={{
				animation: showContent
					? `slideInFromRight ${TIMING.SLIDE_MS}ms ease-out forwards`
					: `slideOutToRight ${TIMING.SLIDE_OUT_MS}ms ease-in ${collapseDelay} forwards`,
				animationDelay: showContent ? expandDelay : undefined,
			}}
		>
			{children}
		</div>
	)
}
